module.exports = __webpack_public_path__ + "static/media/1022689.8b82acf7.jpg";